import React from 'react'
import styled from 'styled-components'

import Card from 'pages/HehmDevice/HehmDashboard/Card'
import NoDataValue from 'pages/HehmDevice/HehmDashboard/NoDataValue'

import { camelToNormalCase, formatStages } from 'helpers/formatters'

import { color } from 'styles/colors'

import { HehmDeviceEquipment, HehmDeviceHardware } from 'types/HehmDevice'

import { screenSize } from 'styles/shared'

type Props = {
  hehmDeviceEquipment: HehmDeviceEquipment | null
  hehmDeviceHardware: HehmDeviceHardware | null
  onNavigate: (tab: string) => void
}

const ConfigurationAndComponentsCard = ({ hehmDeviceEquipment, hehmDeviceHardware, onNavigate }: Props) => {
  return (
    <Card
      title="Configuration"
      icon="/img/sensor.svg"
      onClick={() => onNavigate('config-components')}
    >
      <S.Configuration>
        <div>
          <Card.ItemLabel>OD Unit</Card.ItemLabel>
          <S.SmallLabel>Type: {camelToNormalCase(hehmDeviceEquipment?.outdoor?.type) || <S.NoDataValue />}</S.SmallLabel>
          <S.SmallLabel>Stage: {formatStages(hehmDeviceEquipment?.outdoor?.stages) || <S.NoDataValue />}</S.SmallLabel>
          <S.SmallLabel>Tonnage: {hehmDeviceEquipment?.outdoor?.tonnage || <S.NoDataValue />}</S.SmallLabel>
          <S.SmallLabel>Refrigerant Type: {hehmDeviceEquipment?.outdoor?.refrigerantType || <S.NoDataValue />}</S.SmallLabel>
        </div>

        <div>
          <Card.ItemLabel>ID Unit</Card.ItemLabel>
          <S.SmallLabel>Type: {camelToNormalCase(hehmDeviceEquipment?.indoor?.type) || <S.NoDataValue />}</S.SmallLabel>
          <S.SmallLabel>Heat Type: {camelToNormalCase(hehmDeviceEquipment?.indoor?.heatType) || <S.NoDataValue />}</S.SmallLabel>
          <S.SmallLabel>Stage: {formatStages(hehmDeviceEquipment?.indoor?.stages) || <S.NoDataValue />}</S.SmallLabel>
        </div>
      </S.Configuration>

      <S.Divider />

      <S.Title>Components (1)</S.Title>

      <div>
        <S.ComponentListRow>
          <Card.ItemLabel>Description</Card.ItemLabel>
          <Card.ItemLabel>Model</Card.ItemLabel>
          <Card.ItemLabel>Warranty</Card.ItemLabel>
        </S.ComponentListRow>

        <S.ComponentListRow>
          <Card.ItemValue>Modem</Card.ItemValue>
          <Card.ItemValue>{hehmDeviceHardware?.moduleInfo?.partNumber || <NoDataValue />}</Card.ItemValue>
          <Card.ItemValue><NoDataValue /></Card.ItemValue>
        </S.ComponentListRow>
      </div>
    </Card>
  )
}

export default ConfigurationAndComponentsCard

const S = {
  Configuration: styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
  `,
  Title: styled.h3`
    text-transform: capitalize;
    font-size: 22px;
  `,
  Divider: styled.div`
    height: 1px;
    background-color: ${color('border')};
    margin: 15px 0;
  `,
  SmallLabel: styled.div`
    display: flex;
    font-size: 14px;
    margin-bottom: 10px;
  `,
  ComponentListRow: styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1fr);
    align-items: start;
    margin-bottom: 10px;

    @media ${screenSize.medium} {
      grid-template-columns: minmax(0, 1fr) minmax(0, 1.7fr) minmax(0, 0.6fr);
    }

    @media ${screenSize.small} {
      grid-template-columns: minmax(0, 1.2fr) minmax(0, 2fr) minmax(0, 1fr);
    }
  `,
  NoDataValue: styled(NoDataValue)`
    margin-left: 5px;
  `
}
